import xs from "xstream"
import isolate from "@cycle/isolate"
import { button, div, input, label, option, select, span, VNode } from "@cycle/dom"
import { apiNG, apiOK, createApiReqEx, createApiResp, doValidation, drawDesc, eventMapper, fmtMember, pageViewTempl } from "../../common"
import { API, INPUT_INFO, PAGE, PREFECTURES, STATE_KEY } from "../../../constant"
import { style } from "typestyle"
import * as R from "ramda"
import { AddressForm, InputCheck, WorkForm } from "../../../interface"
import sampleCombine from "xstream/extra/sampleCombine"
import delay from "xstream/extra/delay"

const linkFrame = style(
  {
    color: "#666",
  },
)
const retFrame = style({
  display: "flex",
  justifyContent: "flex-end",
})

const drawButtonLink = (path:string, label: string, type = "primary",  desc?: string | undefined) => {
  return div(`.col.col-md-5.${linkFrame}`, [
    button(`.btn.btn-${type}.w-100`, { attrs: { "data-path": path } }, [label]),
    desc ? div(["※", desc]) : null,
  ])
}

const view = (mailAddress$: xs<string | null>) => {
		return mailAddress$
    .map((mailAddress) => {
      console.log(mailAddress)
      const disabled = mailAddress ? "" : ".disabled"
      return div([
        div(`.${retFrame}`, [
          button(".btn.btn-success.btnReturn3.btn-sm", ["戻る"]),
        ]),
        div(".pointView", [
          div(".topPanel", [
            // label(["【メニュー】"]),
            div(".d-grid.gap-4.mt-4", [
              drawButtonLink("/member/password", "パスワード変更"),
              drawButtonLink("/member/mail", "メールアドレス変更依頼"),
              disabled ? div(".border.border-danger.border-2.p-2.col-md-5.text-danger.fw-bold", [
                "※メールアドレスが登録されていないため、以下の変更依頼は利用できません。メールアドレスの登録をしてください。",
              ]) : null,
              drawButtonLink("/member/profile/base", "基本情報変更依頼", `outline-success${disabled}`, "ご氏名、日産婦／泌尿器会員番号の登録／変更"),
              drawButtonLink("/member/profile/work", "連絡先情報変更依頼",`outline-success${disabled}` , "お届け先、勤務先情報、自宅住所の変更"),
              // drawButtonLink("/member/profile/address", "自宅住所変更依頼", `outline-success${disabled}`),
              drawButtonLink("/member/profile/recess", "留学・休会依頼", `outline-danger${disabled}`),
              drawButtonLink("/member/profile/withdrawal", "退会依頼", `outline-danger${disabled}`),
            ]),
          ]),
        ])
      ])
    })
}

const ProfileMenu = (sources: any) => {
  const btnReturn$ = sources.DOM.select(".btnReturn3").events("click").mapTo({type: "goBack"})
  const btnLink$ = sources.DOM.select(".topPanel .btn").events("click")
    .map((e: MouseEvent) => {
      return R.path(["target", "dataset", "path"])(e)
    })
  const pageView = pageViewTempl(PAGE.Profile.id)
	const mailAddress$ = sources.state.select([STATE_KEY.User, "mailAddress"])
  return {
    DOM: pageView(view(mailAddress$)),
    router: xs.merge(btnReturn$, btnLink$),
  }
}
export default isolate(ProfileMenu)

export const prefOptions = (selected?: string) =>
  R.map((value: string) =>
    option(
      {
        attrs: { value },
        props: { selected: selected === value },
      },
      [value],
    ),
  )(PREFECTURES)

export const createPrefSelect = (key: string) => (userForm: any, errorCheck: any, readOnly = false) => {
  const check = R.path([key, "check"], errorCheck)
  const errMsg = check || readOnly ? null  : R.path([key, "message"], errorCheck)
  const valid = check || readOnly ? "" : ".is-invalid"
  return div([
    select(
      `.form-select.form-select-sm${valid}`,
      { attrs: { name: key, disabled: readOnly } },
      prefOptions(R.prop(key, userForm)),
    ),
    errMsg ? div(".invalid-feedback.d-block", [errMsg]) : null,
  ])
}

export const yearOptions = (selected?: string) => {
  const year = new Date().getFullYear()
  const years = R.range(year, year + 10)
  return R.map((value: number) =>
    option(
      {
        attrs: { value },
        props: { selected: selected === value.toString() },
      },
      [value.toString()],
    ),
  )(years)
}
export const monthOptions = (selected?: string) => {
  return R.map((value: number) =>
    option(
      {
        attrs: { value },
        props: { selected: selected === value.toString() },
      },
      [value.toString()],
    )
  )(R.range(1, 13))
}

export const createZipInputs = (
  userForm: any,
  errorCheck: any,
  zipMsg: string | null,
  readOnly = false
) => {
  const zip1 = R.propOr("", "zip1", userForm)
  const zip2 = R.propOr("", "zip2", userForm)
  const zipErr1 = R.pathOr(false, ["zip1", "check"], errorCheck)
  const zipErr2 = R.pathOr(false, ["zip2", "check"], errorCheck)
  const errMsg =
    !(zipErr1 && zipErr2 ) ? R.path(["zip1", "message"], errorCheck) : null
  const zip1Class = readOnly
    ? "form-control-plaintext"
    : zipErr1 ? "" : "is-invalid"
  const zip2Class = readOnly
    ? "form-control-plaintext"
    : zipErr2 ? "" : "is-invalid"
  return div(".mt-0", [
    div(".d-flex.align-items-center.col-md-6.mt-0", [
      span(["〒"]),
      input(`.form-control.${zip1Class}`, {
        attrs: {
          type: "text",
          name: "zip1",
          minLength: 3,
          maxLength: 3,
          inputmode: "numeric",
          readOnly,
        },
        props: { value: zip1 },
      }),
      span(["-"]),
      input(`.form-control.${zip2Class}`, {
        attrs: {
          type: "text",
          name: "zip2",
          minLength: 4,
          maxLength: 4,
          inputmode: "numeric",
          readOnly,
        },
        props: { value: zip2 },
      }),
      button(
        "#btnAddr.btn.btn-primary.btn-sm.ms-2.flex-shrink-0",
        { attrs: { type: "button", disabled: !(zipErr1 && zipErr2) } },
        ["検索"],
      ),
    ]),
    errMsg
      ? div(".invalid-feedback.d-block", [errMsg])
      : zipMsg
      ? div(".invalid-feedback.d-block", [zipMsg])
      : null,
  ])
}

export const drawAddrSelect = (userForm: WorkForm | AddressForm, readOnly: boolean) => {
  const desc = INPUT_INFO.addrSelect.desc
  return div([
    div(".form-check.form-check-inline", [
      label(".pure-radio", { attrs: { for: "r1" } }, [
        input("#r1.form-check-input", {
          attrs: { type: "radio", name: "addrSelect", value: "勤務先", disabled: readOnly },
          props: { checked: R.prop("addrSelect", userForm) === "勤務先" },
        }),
        "勤務先"
      ]),
    ]),
    div(".form-check.form-check-inline", [
      label(".pure-radio", { attrs: { for: "r2" } }, [
        input("#r2.form-check-input", {
          attrs: { type: "radio", name: "addrSelect", value: "ご自宅", disabled: readOnly },
          props: { checked: R.prop("addrSelect", userForm) === "ご自宅" },
        }),
        "ご自宅"
      ]),
    ]),
  ])
}

const modifyReq = createApiReqEx("modify")
const modifyResp = createApiResp("modify")
const zipLookupReq = createApiReqEx("zipLookup")
const zipLookupResp = createApiResp("zipLookup")

type ViewFunc = (form$: xs<any>, user$: xs<any>, zipMsg$: xs<string | null>, isConfirm: boolean) => xs<VNode>
type GetParamFunc = ([user, form]) => any

export const Form = (name: string, stateKey: string, view: ViewFunc, inputChecks: InputCheck[]) => (sources: any) => {
  const btnConfirm$ = sources.DOM.select("#btnConfirm").events("click")
  const btnReturn$ = sources.DOM.select("#btnReturn").events("click")
    .mapTo({ type: "goBack" })

  const initAddressForm$ = sources.state.select([stateKey])

  const textInput$ = sources.DOM.select(
    'input[type="text"], select, input[type="radio"], textarea',
  )
    .events("change")
    .map(R.path(["target"]))
    .map(eventMapper("name", "value"))

  const cbInput$ = sources.DOM.select('input[type="checkbox"]')
    .events("change")
    .map(R.path(["target"]))
    .map(eventMapper("name", "checked"))

  const inputAddressForm$ = xs.merge(textInput$, cbInput$)

  const zipClick$ = sources.DOM.select("#btnAddr").events("click")
    .map(R.path(["target", "dataset"]))
    .remember()

  const zipResp$ = zipLookupResp(sources.HTTP)
  const zipOk$ = zipResp$.filter(R.has("data")).map((resp: any) => {
    const data = R.path(["data", 0, "ja"], resp)
    const addr1: string = R.propOr("", "address1", data)
    const addr2: string = R.propOr("", "address2", data)
    const addr3: string = R.propOr("", "address3", data)
    const addr4: string = R.propOr("", "address4", data)
    const prefecture: string = R.propOr("", "prefecture", data)
    return zipClick$
      .map(({ pref, addr }) => {
        return { [addr]: addr1 + addr2 + addr3 + addr4, [pref]: prefecture }
      })
      .take(1)
  })
  .flatten()

  const zipNg$ = zipResp$
    .filter(R.has("status"))
    .mapTo("郵便番号情報が見つかりませんでした。")

  const zipMsg$ = xs
    .merge(zipNg$, zipClick$.mapTo("検索中..."), zipOk$.mapTo(null))
    .startWith(null) as xs<string | null>


  const userForm$ = xs
    .merge(initAddressForm$, inputAddressForm$, zipOk$)
    .fold((acc, cur) => {
      return Object.assign(acc, cur)
    }, {})
    .remember()


  const errorCheck$ = userForm$.map(doValidation(inputChecks))

  const pageView = pageViewTempl(PAGE.Profile.id)
  const view$ = view(
    userForm$ as xs<any>,
    errorCheck$,
    zipMsg$,
    false,
  )

  const updateState$ = btnConfirm$
    .compose(sampleCombine(userForm$))
    .map(([_, userForm]: [any, any]) => R.assoc(stateKey, userForm))

  const toConfirm$ = btnConfirm$
    .compose(delay(100))
    .mapTo(`/member/profile/${name}/confirm`)

  const zipLookup$ = zipClick$
    .map((dataset: any) => {
      const key1 = R.prop("key1", dataset)
      const key2 = R.prop("key2", dataset)
      return userForm$
        .map((form: any) => {
          const zip1 = R.prop(key1, form) 
          const zip2 = R.prop(key2, form) 
          return zipLookupReq({ url: API["zipLookup"](zip1, zip2), method: "GET", headers: {} })
        })
        .take(1)
    })
    .flatten()

  const onLoad$ = xs
    .of(1)
    .debug(() => window.scrollTo({ top: 0, left: 0, behavior: "auto" }))

  return {
    HTTP: zipLookup$,
    DOM: pageView(view$),
    router: xs.merge(toConfirm$, btnReturn$),
    state: updateState$,
    dumper: xs.merge(onLoad$, zipClick$),
  }
}


export const Confirm = (formKey: string, view: ViewFunc, getReqParam: GetParamFunc) => (sources: any) => {
	const user$ = sources.state.select([STATE_KEY.User])
  const form$ = sources.state.select([formKey])
  const btnSend$ = sources.DOM.select("#btnSend").events("click")
    .mapTo(xs.combine(user$, form$)
      .map(([user, form]) => {
        const memberId = fmtMember(R.prop("id", user))
        const send = R.mergeLeft({ memberId }, getReqParam([user, form]))
        return modifyReq({ send })
      })
      .take(1)
    )
    .flatten()

  const btnReturn$ = sources.DOM.select("#btnReturn").events("click")
    .mapTo({ type: "goBack" })


  const pageView = pageViewTempl(PAGE.Profile.id)
  const view$ = view(form$ as xs<any>, xs.of({}), xs.of(null), true)


  const onLoad$ = xs
    .of(1)
    .debug(() => window.scrollTo({ top: 0, left: 0, behavior: "auto" }))

  const resp$ = modifyResp(sources.HTTP)
  const respOK$ = resp$
      .filter(apiOK)
      .map(R.prop("data"))
      .mapTo(`/member/profile/complete/${formKey}`)
  const respNG$ = resp$
      .filter(apiNG)
      .map(R.prop("message"))

  const loading$ = xs.merge(btnSend$.mapTo(true), resp$.mapTo(false)).startWith(false)

  const route$ = xs.merge(btnReturn$, respOK$)
  return {
    DOM: pageView(view$),
    HTTP: xs.merge(btnSend$),
    router: route$,
    dumper: xs.merge(onLoad$, respOK$),
    loading: loading$,
    MSG: respNG$,
  }
}

const RE_NON_CHANGE = new RegExp(`/(${STATE_KEY.WithdrawalForm}|${STATE_KEY.RecessForm})$`)
const _ModifyComplete = (sources: any) => {

  const view$ = sources.router.path().history$
    .map(({ pathname }: any) => {
      const word = RE_NON_CHANGE.test(pathname) ? "" : "完了の"
      return div([
        div(".fw-bold", ["ご依頼を受け付けました。"]),
        div(".mt-2", ["※ご依頼内容に関して担当者よりご連絡させていただくことがあります。"]),
        div([`※10営業日以上たっても${word}ご連絡がない場合には、必ず事務局までお問合せください。`]),
        div(".mt-4.d-grid.col-md-4",[
          button(".btn.btn-primary", ["戻る"]),
        ]),
      ])
    }
  )

  return {
    DOM: pageViewTempl(PAGE.Profile)(view$),
    dumper: sources.DOM.select(".btn").events("click").debug(() => window.history.go(-3)),
  }
}

export const ModifyComplete = isolate(_ModifyComplete)

